module.exports = __webpack_public_path__ + "static/media/Right Lateral Z1.ba853c88.png";